export const getTrackingDetail = async (token, trackNo) => {
  const url = "https://trackapi.thailandpost.co.th/post/api/v1/track";
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify({
      "status": "all",
      "language": "TH",
      "barcode": [
        trackNo
      ]
    })
  });
  if (response.ok) {
    const data = await response.json();
    return { status: true, ...data };
  } else {
    return { status: false, code: `${response.status} - 2 ` }
  }
}